import type { RechercheDossierQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { buildRechercheStore } from '../shared'

export const useRechercheDossierStore = buildRechercheStore<RechercheDossierQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDossierStore',
  apiPath: '/dossiers',
  location: {
    to: 'recherche',
    domaine: 'formations',
    module: 'dossier'
  }
})

